var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCoffee(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: 64,
    width: 64,
    viewBox: "0 0 64 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "coffee maker") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    strokeLinecap: "round",
    strokeWidth: 3,
    fill: "none",
    stroke: "currentColor",
    strokeLinejoin: "round",
    className: "nc-icon-wrapper"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M46,57 L46,57c-6.1,0-11-4.9-11-11v-9h22v9C57,52.1,52.1,57,46,57z"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 35,
    y1: 62,
    x2: 57,
    y2: 62
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35,37h-6 v4c0,2.2,1.8,4,4,4h2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2,22V2h53c3.9,0,7,3.1,7,7 l0,0c0,3.9-3.1,7-7,7H18l0,12v34H2V28V22z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42,28.2c0-2.4,4-7.2,4-7.2 s4,4.9,4,7.2S48,32,46,32S42,30.6,42,28.2z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoffee);
export default __webpack_public_path__ + "static/media/coffee.2a7754d10c680066251c8d1e2c2336c2.svg";
export { ForwardRef as ReactComponent };